import { Provider } from '@angular/core';
import { PaginatedStateLoadingMode } from '@shared/ui';

import { methodTypeListStoreProviders } from '../../../providers/store.providers';

import { MethodTypeManagerFacade } from './method-type-manager.facade';

/**
 * Providers for one method-type manager instance
 *
 * NOT self-resolvable. The OUTERMOST consumer (the case-type editor page) must
 * also provide, reachable through the injector chain:
 * - `METHOD_TYPE_MANAGER_CONTEXT` (the case-type id + persisted flag);
 * - the shared `StagedMethodTypesState` / `AssignedMethodTypesState` ledgers
 *   this manager writes (owned by the outermost consumer so they survive a
 *   manager unmount and feed the future `consolidateCaseType`). The assigned
 *   ledger is seeded by the consumer with the case type's persisted method types;
 * - the method-type editor session scope the editor DIALOG resolves against —
 *   `methodTypeEditorProviders` plus the editor's embedded manager tiers and the
 *   `pipelineEditorCascadeProviders` cascade/label/staging tier (i.e. the same
 *   composition as `methodTypeEditorPageProviders`). It is deliberately NOT
 *   bundled here: the embedded pipeline/resource managers read their context
 *   tokens once at construction, so the case-type editor owns how that scope is
 *   composed (see the per-open-context note in the manager component).
 */
export function methodTypeManagerProviders(
  pagination: PaginatedStateLoadingMode = PaginatedStateLoadingMode.PAGINATED
): Provider[] {
  return [...methodTypeListStoreProviders(pagination), MethodTypeManagerFacade];
}
